// extracted by mini-css-extract-plugin
module.exports = {"container":"container___3jymT","smallContainer":"smallContainer___1JXO4","largeContainer":"largeContainer___1ve6B","text":"text___34YRE"};